import { useQuery } from 'react-apollo';

import { MeQuery } from '../../../../graphql/queries/account';
import { gtm } from '../../../../util/analytics';

export const WG_FOR_BUSINESS_EVENT_TYPE = 'Waldograms for Business';

/**
 * Tracks events for the Waldograms for Business feature.
 *
 * @returns {function}
 */
const useWaldogramsForBusinessEvent = () => {
  const { data: { me: user } = {} } = useQuery(MeQuery);

  return ({ action, label, ...data }) => {
    gtm.trackEvent({
      type: WG_FOR_BUSINESS_EVENT_TYPE,
      action,
      label,
      userId: user?.id,
      ...data,
    });
  };
};

export default useWaldogramsForBusinessEvent;
